export default {
  header: {
    title: 'Rewards',
  },
  content: {
    title: 'You have {{balance}} points',
    description: 'Spend {{amount}}, get {{rewards}} points! Add free items to your cart with your earned points.',
    articles: {
      title: 'Earn points with every order',
      spend_description: 'Every {{amount}} you spend adds {{rewards}} points to your account.',
      redeem_title: 'Redeem your points',
      redeem_description:
        'Redeem your points for free treats! Start earning rewards at {{minSpendingLimit}} points, equivalent to {{amount}} spent',
      discounts_title: 'Discover exclusive perks',
      discounts_description: 'Unlock exclusive deals, offers, and discounts.',
    },
  },
};
